import { OptionalLink } from '../01-core/OptionalLink';
import { Icon } from './Icon';

export interface ChipProps {
  /** Tag label */
  label: string;
  /** Title on tag */
  title?: string;
  /** Link on tag */
  href?: string;
  /** Add remove icon */
  remove?: boolean;
  /** Additional class */
  className?: string;
  /** Discreet */
  discreet?: boolean;
  /** Optional click handler */
  onClick?: () => void;
}

/** A removable chip */
export const Chip = ({
  label,
  title,
  href,
  remove,
  className,
  discreet,
  ...props
}: ChipProps) => {
  return (
    <OptionalLink
      button={true}
      div={true}
      className={['chip', discreet ? 'chip--discreet' : '', className].join(
        ' ',
      )}
      href={href}
      title={title}
      {...props}
    >
      {remove && <Icon className="chip__icon" icon="cancel_circle" />}
      {label}
    </OptionalLink>
  );
};
